(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[147],{

/***/ 83894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ endOfDay; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */

function endOfDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),

/***/ 1088:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/past-local",
      function () {
        return __webpack_require__(23520);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ StickyMenuProvider; },
/* harmony export */   "W": function() { return /* binding */ StickyMenuContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36305);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var rambda__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49713);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





var StickyMenuContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)({
    activeSection: null,
    registeredSections: [],
    registerSection: function() {
        return null;
    },
    handleActiveSectionChange: function() {
        return null;
    }
});
var StickyMenuProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), registeredSections = ref[0], setRegisteredSections = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), activeSection = ref1[0], setActiveSection = ref1[1];
    var _index, _index1;
    var registerSection = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(section) {
        return setRegisteredSections(function(state) {
            return (0,rambda__WEBPACK_IMPORTED_MODULE_3__.sort)(function(a, b) {
                return ((_index = a.index) !== null && _index !== void 0 ? _index : 0) > ((_index1 = b.index) !== null && _index1 !== void 0 ? _index1 : 0) ? 1 : 0;
            }, (0,lodash__WEBPACK_IMPORTED_MODULE_1__.uniqBy)((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(state).concat([
                section
            ]), function(s) {
                return s.id;
            }));
        });
    }, [
        setRegisteredSections
    ]);
    var handleActiveSectionChange = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(value) {
        setActiveSection(value);
    }, [
        setActiveSection
    ]);
    var value = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return {
            activeSection: activeSection,
            registeredSections: registeredSections,
            registerSection: registerSection,
            handleActiveSectionChange: handleActiveSectionChange
        };
    }, [
        activeSection,
        registeredSections,
        handleActiveSectionChange,
        registerSection, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StickyMenuContext.Provider, {
        value: value,
        children: children
    });
};


/***/ }),

/***/ 25196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ StickyMenu; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(36305);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87379);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73098);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68251);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(17573);
/* harmony import */ var vendor_mods_styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10395);
/* harmony import */ var src_hooks_useRectMeasure__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48101);
/* harmony import */ var src_hooks_useWindowScroll__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87802);
/* harmony import */ var src_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10763);
/* harmony import */ var src_components_common_TabsSwiper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2277);
/* harmony import */ var src_components_common_StickyMenu_StickyMenuContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95175);
/* harmony import */ var src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12732);






function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      right: calc(var(--scrollbar-padding) / 2);\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .sticky-menu__navbar {\n      background: rgba(255, 255, 255, 0.85);\n    }\n    ",
        " {\n      .sticky-menu__navbar {\n        background: ",
        ";\n      }\n      .sticky-menu__button {\n        color: ",
        ";\n        border-color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    backdrop-filter: blur(0px) !important;\n    .sticky-menu__navbar {\n      background: transparent !important;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: ",
        ";\n  top: calc(var(--header-fixed-height));\n\n  ",
        ";\n\n  display: flex;\n  justify-content: center;\n\n  width: 100%;\n  z-index: 10;\n\n  backdrop-filter: blur(8rpx);\n  transform: translate3d(0, 0, 0);\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  padding-top: 8px;\n  padding-bottom: 9px;\n  background: transparent;\n  transition: 0.25s;\n  height: ",
        "px;\n\n  ",
        " {\n    padding-top: 11px;\n    padding-bottom: 13px;\n    height: ",
        "px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: ",
        "px;\n  ",
        " {\n    height: ",
        "px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}













var height = {
    mobile: 42,
    desktop: 52
};
var Container = styled_components__WEBPACK_IMPORTED_MODULE_11__["default"].div.withConfig({
    displayName: "StickyMenu__Container",
    componentId: "sc-1526bfc7-0"
})(_templateObject3(), function(param) {
    var $fixed = param.$fixed;
    return $fixed ? "fixed" : "sticky";
}, function(param) {
    var $fixed = param.$fixed;
    return $fixed && (0,styled_components__WEBPACK_IMPORTED_MODULE_11__.css)(_templateObject());
}, (0,src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_10__/* .casePathEmptyString */ .Q)("$passedBanner")((0,styled_components__WEBPACK_IMPORTED_MODULE_11__.css)(_templateObject1(), src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop, (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .fromTheme */ .HW)(function(theme) {
    return (0,polished__WEBPACK_IMPORTED_MODULE_12__/* .transparentize */ .DZ)(0.15, theme.palette.background);
}), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .fromTheme */ .HW)(function(theme) {
    return theme.text.palette.heavy;
}), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .fromTheme */ .HW)(function(theme) {
    return (0,polished__WEBPACK_IMPORTED_MODULE_12__/* .transparentize */ .DZ)(0.15, theme.text.palette.heavy);
}))), (0,src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_10__/* .casePathEmptyString */ .Q)("$transparent")((0,styled_components__WEBPACK_IMPORTED_MODULE_11__.css)(_templateObject2())));
var Navbar = styled_components__WEBPACK_IMPORTED_MODULE_11__["default"].div.withConfig({
    displayName: "StickyMenu__Navbar",
    componentId: "sc-1526bfc7-1"
})(_templateObject4(), height.mobile, src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, height.desktop);
var FixedNavbarSpaceReservation = styled_components__WEBPACK_IMPORTED_MODULE_11__["default"].div.withConfig({
    displayName: "StickyMenu__FixedNavbarSpaceReservation",
    componentId: "sc-1526bfc7-2"
})(_templateObject5(), height.mobile, src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, height.desktop);
var StickyMenu = function(_param) {
    var _tabs = _param.tabs, tabs = _tabs === void 0 ? [] : _tabs, theme = _param.theme, activeTab = _param.activeTab, bannerHeight = _param.bannerHeight, transparentOnTop = _param.transparentOnTop, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_param, [
        "tabs",
        "theme",
        "activeTab",
        "bannerHeight",
        "transparentOnTop"
    ]);
    var y = (0,src_hooks_useWindowScroll__WEBPACK_IMPORTED_MODULE_7__/* .useWindowScroll */ .b)().y;
    var isDesktop = (0,src_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_14__/* .useMediaQuery */ .a)(src_styles_designs__WEBPACK_IMPORTED_MODULE_3__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, true);
    var ctx = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(src_components_common_StickyMenu_StickyMenuContext__WEBPACK_IMPORTED_MODULE_9__/* .StickyMenuContext */ .W);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,src_hooks_useRectMeasure__WEBPACK_IMPORTED_MODULE_6__/* .useRectMeasure */ .R)(isDesktop ? height.desktop : height.mobile), 2), containerRef = ref[0], navHeight = ref[1];
    var passedBanner = bannerHeight == null || y >= bannerHeight - navHeight;
    var isFixed = !bannerHeight ? false : y > navHeight;
    var allTabs = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(tabs).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(ctx.registeredSections));
    if (allTabs.length < 2) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(vendor_mods_styled_components__WEBPACK_IMPORTED_MODULE_5__/* .Theme */ .Q, {
        theme: theme || (passedBanner ? src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .defaultTheme */ .uH : src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .redTheme */ .MN),
        children: [
            isFixed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FixedNavbarSpaceReservation, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, props), {
                ref: containerRef,
                $fixed: isFixed,
                $passedBanner: passedBanner,
                $transparent: transparentOnTop ? y === 0 : false,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Navbar, {
                    className: "sticky-menu__navbar",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_TabsSwiper__WEBPACK_IMPORTED_MODULE_8__/* .TabsSwiper */ .T, {
                        tabs: allTabs,
                        activeTab: activeTab !== null && activeTab !== void 0 ? activeTab : ctx.activeSection,
                        buttonClassName: "sticky-menu__button"
                    })
                })
            }))
        ]
    });
};


/***/ }),

/***/ 89080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ MetaDescription; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



function MetaDescription(props) {
    var description = props.children;
    return description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }, "description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:description",
                content: description
            }, "og:description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                content: description
            }, "twitter:description")
        ]
    }) : null;
}


/***/ }),

/***/ 51961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ EventsGalleryTemplate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87379);
/* harmony import */ var src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71008);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68251);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73098);
/* harmony import */ var src_components_common_typography_Text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51306);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14332);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(17739);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react_t7e__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12732);
/* harmony import */ var src_components_common_StickyMenu__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25196);
/* harmony import */ var src_components_seo_MetaTitle__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71508);
/* harmony import */ var src_components_seo_MetaDescription__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89080);
/* harmony import */ var src_services_route__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(38325);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 50;\n  width: 100%;\n  pointer-events: none;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        position: static;\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &&& {\n    ",
        ";\n\n    pointer-events: all;\n    .sticky-menu__navbar {\n      background: transparent;\n    }\n    .sticky-menu__button {\n      justify-content: start;\n      ",
        " {\n        min-width: 220px;\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding-bottom: 30px;\n\n      ",
        " {\n        padding-bottom: 100px;\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  padding-top: 100px;\n\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 16px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}














var StickyUIContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__["default"].div.withConfig({
    displayName: "EventsGalleryTemplate__StickyUIContainer",
    componentId: "sc-34bdb64a-0"
})(_templateObject());
var StickyMenuContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__["default"].div.withConfig({
    displayName: "EventsGalleryTemplate__StickyMenuContainer",
    componentId: "sc-34bdb64a-1"
})(_templateObject1());
var StyledStickyMenu = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__["default"])(src_components_common_StickyMenu__WEBPACK_IMPORTED_MODULE_8__/* .StickyMenu */ .a).withConfig({
    displayName: "EventsGalleryTemplate__StyledStickyMenu",
    componentId: "sc-34bdb64a-2"
})(_templateObject3(), (0,src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_7__/* .casePathEmptyString */ .Q)("$static")((0,styled_components__WEBPACK_IMPORTED_MODULE_12__.css)(_templateObject2())), src_styles_designs__WEBPACK_IMPORTED_MODULE_5__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var NoResultsContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__["default"])(src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_3__/* .ConstraintContainer */ .a).withConfig({
    displayName: "EventsGalleryTemplate__NoResultsContainer",
    componentId: "sc-34bdb64a-3"
})(_templateObject5(), (0,src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_7__/* .casePathEmptyString */ .Q)("$space")((0,styled_components__WEBPACK_IMPORTED_MODULE_12__.css)(_templateObject4(), src_styles_designs__WEBPACK_IMPORTED_MODULE_5__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop)));
var NoResultsHeading = styled_components__WEBPACK_IMPORTED_MODULE_12__["default"].h3.withConfig({
    displayName: "EventsGalleryTemplate__NoResultsHeading",
    componentId: "sc-34bdb64a-4"
})(_templateObject6());
var stickyMenuSections = [
    {
        id: "upcoming",
        label: "upcoming events",
        link: src_services_route__WEBPACK_IMPORTED_MODULE_11__/* .route.events */ .BC.events().upcoming()
    },
    {
        id: "past-global",
        label: "past global events",
        link: src_services_route__WEBPACK_IMPORTED_MODULE_11__/* .route.events */ .BC.events().pastGlobal()
    },
    {
        id: "past-local",
        label: "past local events",
        link: src_services_route__WEBPACK_IMPORTED_MODULE_11__/* .route.events */ .BC.events().pastLocal()
    }, 
];
var EventsGalleryTemplate = function(param) {
    var type = param.type, children = param.children, hasResults = param.hasResults, _staticMenu = param.staticMenu, staticMenu = _staticMenu === void 0 ? false : _staticMenu;
    var _ = (0,react_t7e__WEBPACK_IMPORTED_MODULE_13__.useTranslate)()._;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_seo_MetaTitle__WEBPACK_IMPORTED_MODULE_9__/* .MetaTitle */ .p, {
                children: _("seo.events.title", "events.".concat(type))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_seo_MetaDescription__WEBPACK_IMPORTED_MODULE_10__/* .MetaDescription */ .l, {
                children: _("seo.events.description", "events.".concat(type))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StickyUIContainer, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyMenuContainer, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledStickyMenu, {
                            $static: staticMenu,
                            tabs: stickyMenuSections,
                            theme: hasResults && !staticMenu ? src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .redTheme */ .MN : src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .defaultTheme */ .uH,
                            activeTab: type,
                            transparentOnTop: !staticMenu
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_14__/* .AnimatePresence */ .M, {
                        exitBeforeEnter: true,
                        initial: false,
                        children: children
                    })
                ]
            }),
            !hasResults && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(NoResultsContainer, {
                $space: type === "upcoming",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(NoResultsHeading, {
                        children: _("Currently, there are no events in this category")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_typography_Text__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .n, {
                        children: _("Please use different one, or come back later!")
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 23520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ past_local; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/modules/events/components/EventsGridGallery/index.tsx + 2 modules
var EventsGridGallery = __webpack_require__(76424);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/hooks/useAPIs.ts
var useAPIs = __webpack_require__(53100);
// EXTERNAL MODULE: ./src/models/query.ts
var query = __webpack_require__(19162);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/endOfDay/index.js
var endOfDay = __webpack_require__(83894);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(78420);
// EXTERNAL MODULE: ./src/modules/events/hooks/useEventsListQuery.ts + 1 modules
var useEventsListQuery = __webpack_require__(56760);
;// CONCATENATED MODULE: ./src/modules/events/hooks/usePastLocalEventsListQuery.ts







var fetchPastLocalEventsList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(apis) {
        var events;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,useEventsListQuery/* fetchEventsList */.l)(apis, {
                            filters: {
                                endDate: {
                                    _lte: (0,endOfDay/* default */.Z)(new Date()).toISOString()
                                },
                                reach: {
                                    _eq: "local"
                                }
                            }
                        })
                    ];
                case 1:
                    events = _state.sent();
                    return [
                        2,
                        events.filter(function(event) {
                            return (0,parseISO/* default */.Z)(event.endDate).getTime() <= new Date().getTime();
                        }).sort(function(a, b) {
                            return (0,parseISO/* default */.Z)(b.startDate).getTime() - (0,parseISO/* default */.Z)(a.startDate).getTime();
                        })
                    ];
            }
        });
    });
    return function fetchPastLocalEventsList(apis) {
        return _ref.apply(this, arguments);
    };
}();
var usePastLocalEventsListQuery = function() {
    var apis = (0,useAPIs/* useAPIs */.V)();
    return (0,es.useQuery)(query/* QueryKey.PastLocalEventsList */.S.PastLocalEventsList, function() {
        return fetchPastLocalEventsList(apis);
    });
};

// EXTERNAL MODULE: ./src/modules/events/templates/EventsGalleryTemplate.tsx
var EventsGalleryTemplate = __webpack_require__(51961);
;// CONCATENATED MODULE: ./src/modules/events/templates/PastLocalEventsTemplate.tsx





var PastLocalEventsTemplate = function() {
    var ref = usePastLocalEventsListQuery(), events = ref.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventsGalleryTemplate/* EventsGalleryTemplate */.a, {
        type: "past-local",
        hasResults: !!(events === null || events === void 0 ? void 0 : events.length),
        staticMenu: true,
        children: events && events.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventsGridGallery/* EventsGridGallery */.C, {
            events: events
        })
    });
};

;// CONCATENATED MODULE: ./src/pages/events/past-local.tsx

var __N_SSP = true;
/* harmony default export */ var past_local = (PastLocalEventsTemplate);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6159,9774,2888,179], function() { return __webpack_exec__(1088); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);